import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Eye, X } from 'lucide-react';

const ImpersonationBanner = () => {
  const { user, isImpersonating, endImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating || !user) return null;

  const handleExit = async () => {
    await endImpersonation();
    navigate('/admin/users', { replace: true });
  };

  return (
    <div
      className="bg-amber-500 text-white px-4 py-2.5 flex items-center justify-center gap-3 text-sm sticky top-0 z-[60] shadow-md"
      data-testid="impersonation-banner"
    >
      <Eye size={16} className="flex-shrink-0" />
      <span className="truncate">
        Viewing as <strong>{user.email}</strong>
      </span>
      <span className="hidden sm:inline text-amber-100">
        (read/write enabled, delete/billing blocked)
      </span>
      <button
        onClick={handleExit}
        className="ml-2 flex items-center gap-1.5 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-full text-xs font-medium transition-colors"
        data-testid="impersonation-exit-btn"
      >
        <X size={12} />
        Exit
      </button>
    </div>
  );
};

export default ImpersonationBanner;
